import AwardsService from '@/services/AwardsService.js';

export default {
    methods: {
        async getUserProfile() {
            this.loading=true
            AwardsService.getUserProfile(this.accessToken)
            .then(
                (user => {
                this.$set(this, "user", user);
                this.loading=false
                }).bind(this)
            );
        },
        async getVolunteer() {
			this.loading = true
			AwardsService.getVolunteer(this.accessToken, this.$route.params.id)
			.then(
				(volunteer => {
				this.$set(this, "volunteer", volunteer);
                this.loading = false
				}).bind(this)
			);
		},
        async getMyOrganisations() {
			this.loading = true
			AwardsService.getMyOrganisations(this.accessToken, this.search)
			.then(
				(organisations => {
				this.$set(this, "organisations", organisations);
                this.loading = false
				}).bind(this)
			);
		},
        async getOrganisations() {
			this.loading = true
			AwardsService.getOrganisations(this.accessToken, this.search)
			.then(
				(organisations => {
				this.$set(this, "organisations", organisations);
                this.loading = false
				}).bind(this)
			);
		},
        async getOrganisation() {
			this.loading = true
			AwardsService.getOrganisation(this.accessToken, this.$route.params.id)
			.then(
				(organisation => {
				this.$set(this, "organisation", organisation);
                this.loading = false
				}).bind(this)
			);
		},
        logout() {
            if(confirm('Are you sure you want to logout ?'))
            {
              this.$auth.logout({
                  returnTo: window.location.origin
              });
            }
          }      
    },
    created() {
      
    },
    mounted() {
     
    },
    destroyed() {
      
    }
  };